module.exports = __webpack_public_path__ + "media/assets/images/logo_coe-22579836d0f53395f610aa4897959e32.svg";